import styled from 'styled-components';
import {
  companyColor,
  defaultColor,
  font,
  fluidFont,
  radius,
} from 'styles/theme';

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PageButton = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: ${radius('small')};
  font-family: ${font('semibold')};
  ${fluidFont('12px', '13px')};
  color: ${({ $active }) => ($active ? defaultColor('white') : companyColor('font'))};
  background-color: ${({ $active }) => ($active ? companyColor('main') : 'transparent')};
  transition: background-color 210ms linear;

  &:hover {
    background-color: ${({ $active }) => (
    $active ? companyColor('main', 0.5) : defaultColor('background')
  )};
  }

  &:focus-visible {
    outline: 2px solid ${defaultColor('blue')};
  }
`;

export const ArrowButton = styled(PageButton)`
  font-size: 18px;
  line-height: 1;

  &:disabled {
    color: ${defaultColor('metallic')};
    cursor: default;
    pointer-events: none;
  }
`;

export const Ellipsis = styled.span`
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${defaultColor('metallic')};
  ${fluidFont('12px', '13px')};
`;
